module.exports = __webpack_public_path__ + "img/userB03.6a558f6c.jpg";